import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllSubDepartments,
  onCreateSubDepartment,
  onDeleteSubDepartment,
  onGetSubDepartment,
  onUpdateSubDepartment,
} from '../../../app/modules/system-definitions/components/sub-departments/core/_requests'
import {
  onGetDepartmentsByFacultyId,
  onGetFaculties,
  onGetUniversities,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface SubDepartmentState {
  subDepartments: any
  subDepartment: any
  faculties: any
  departments: any
  universities: any
  isLoading: boolean
}
const initialState = {
  subDepartments: [],
  faculties: [],
  departments: [],
  universities: [],
  subDepartment: null,
  isLoading: true,
} as SubDepartmentState

export const fetchUniversities = createAsyncThunk('subDepartment/fetchUniversities', async () => {
  const data: any = await onGetUniversities()
  return data.data.result
})

export const fetchFaculties = createAsyncThunk(
  'subDepartment/fetchFaculties',
  async (param: any) => {
    const data: any = await onGetFaculties()
    return data.data.result
  }
)

export const fetchDepartments = createAsyncThunk(
  'subDepartment/fetchDepartments',
  async (param: any) => {
    const data: any = await onGetDepartmentsByFacultyId(param)
    return data.data.result
  }
)

export const fetchSubDepartments = createAsyncThunk(
  'subDepartment/fetchSubDepartments',
  async (param: any) => {
    const data: any = await onGetPagedAllSubDepartments(param)
    return data.data.result
  }
)

export const fetchSubDepartment = createAsyncThunk(
  'subDepartment/fetchSubDepartment',
  async (param: any) => {
    const data: any = await onGetSubDepartment(param)
    return data.data.result
  }
)

export const updateSubDepartment = createAsyncThunk(
  'subDepartment/updateSubDepartment',
  async (param: any) => {
    const data: any = await onUpdateSubDepartment(param)
    return data.data
  }
)

export const createSubDepartment = createAsyncThunk(
  'subDepartment/createSubDepartment',
  async (param: any) => {
    const data: any = await onCreateSubDepartment(param)
    return data.data
  }
)

export const deleteSubDepartment = createAsyncThunk(
  'subDepartment/deleteSubDepartment',
  async (param: any) => {
    const data: any = await onDeleteSubDepartment(param)
    return data.data
  }
)

const subDepartmentSlice = createSlice({
  name: 'subDepartment',
  initialState,
  reducers: {
    clearSubDepartments: (state) => {
      state.subDepartments = []
    },
    clearSubDepartment: (state) => {
      state.subDepartment = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSubDepartments.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchSubDepartments.fulfilled, (state: any, action) => {
      state.subDepartments = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchSubDepartments.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchSubDepartment.fulfilled, (state: any, action) => {
      state.subDepartment = action.payload
    })
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload.items
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload.items
    })
    builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
      state.departments = action.payload.items
    })
  },
})

export const {clearSubDepartments, clearSubDepartment, activateLoading} = subDepartmentSlice.actions

export default subDepartmentSlice.reducer
